export default "__VITE_ASSET__BzcfP31k__"